module.exports = __webpack_public_path__ + "img/img3.6b1eed3b.png";